import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-admin-load-more',
  templateUrl: './admin-load-more.component.html',
  styleUrls: ['./admin-load-more.component.scss']
})
export class AdminLoadMoreComponent {
  @Output() click = new EventEmitter<void>();

  handleClick() {
    this.click.emit();
  }
}
